import { Component, OnInit, TemplateRef } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {MatSnackBar as MatSnackBar } from "@angular/material/snack-bar";
import {MatDialog as MatDialog,MatDialogRef as MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { AddFolderDialogComponent } from "./add-folder-dialog/add-folder-dialog.component";
import { ViewFileComponent } from "./view-file/view-file.component";
import {MatTableDataSource as MatTableDataSource } from "@angular/material/table";
import { AuthService } from "../../services/auth.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { saveAs } from "file-saver";
import { SnotifyService, SnotifyPosition, ToastDefaults } from "ng-snotify";
import { DuplicatedFileComponent } from "./Duplicated-file/Duplicated-file.component";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-media-manager",
  templateUrl: "./media-manager.component.html",
  styleUrls: ["./media-manager.component.css"],
})
export class MediaManagerComponent implements OnInit {
  currentFolder: any = { folderPath: "" };
  currentFolderToMove: any = { folderPath: "" };
  parentFolder: number = null;
  foldersPath: any[] = [];
  foldersPathToMove: any[] = [];
  parentFolderPath: any;
  parentFolderPathMove: any;
  showGrid: boolean = true;
  showTable: boolean = false;
  displayedColumns: string[] = ["Name", "Type", "URL", "actions"];
  dataSource = new MatTableDataSource();
  arryfile: any[] = [];
  btnAll: boolean = true;
  btnImages: boolean = false;
  btnVideos: boolean = false;
  btnDocs: boolean = false;
  btnFiles: boolean = false;
  mediaImages: any[] = [];
  mediaDocs: any[] = [];
  mediaFiles: any[] = [];
  mediaVideo: any[] = [];
  modalRef: BsModalRef | null;
  replaceMediaModal: BsModalRef;
  modalRefImg: BsModalRef | null;
  modalMove: BsModalRef;
  moveModal: BsModalRef;
  showEditor: boolean = false;
  assigned: any[] = [];
  selectedFolder: any;
  data: any = {};
  folders: any[] = [];
  FolderToMove: any[] = [];
  allMedia: any[] = [];
  foldersPathMove: any[] = [];
  requestOptions: { headers: HttpHeaders };
  user: any;
  searchText: any = "";
  folderToEdit: any = {};
  popup: any;
  event: any;
  droppedFolder = [];
  dragEnabled = true;
  foldertDropEnabled = true;
  timestamp = new Date().getTime();

  constructor(
     private snotifyService: ToastrService,
    private authService: AuthService,
    private modalService: BsModalService,
    private httpClient: HttpClient,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private router: ActivatedRoute
  ) {
    
  }
  ngOnInit() {
    this.user = this.authService.getLoggedUser();
    this.requestOptions = {
      headers: new HttpHeaders({
        SiteId: this.user.siteId + "",
        UserId: this.user.id,
      }),
    };
    this.GetFolderMediaAndFolders();
    // this.getFolders();
  }
  getFolders(path?) {
    this.currentFolderToMove.folderPath = path ? path : "";

    this.httpClient
      .post("/Media/GetFolderContent", { folderPath: path ? path : null })
      .subscribe((res: any) => {
        //this.foldersPathToMove = [];
        this.FolderToMove = res.folders;
        this.parentFolderPathMove = res.parentFolderPath;
      });
  }
  openFoldersModal() {
    this.foldersPathToMove = [];
    this.selectedFolder = "";
    this.getFolders();
  }
  openFolderToMove(folder, dontAddBread?) {
    this.currentFolderToMove = folder;
    this.selectedFolder = "";
    if (!dontAddBread) {
      this.foldersPathToMove.push(this.currentFolderToMove);
    }
    this.getFolders(folder.folderPath);
    // this.assigned = []
  }
  openParentFolderToMove(f?, i?) {
    this.foldersPathToMove.splice(i + 1);
    this.currentFolderToMove = [];
    this.getFolders(f.folderPath);
  }
  moveFilesToFolder() {
    var filesNames = [];
    for (let i = 0; i < this.assigned.length; i++) {
      const element = this.assigned[i];
      filesNames.push(element.fileName);
    }

    var data = {
      OldPath: this.currentFolder.folderPath,
      NewPath: this.selectedFolder.folderPath,
      FilesNames: filesNames,
    };

    this.httpClient.post("/Media/MoveFilesToFolder", data).subscribe(
      (res: any) => {
        this.foldersPath = [];
        this.GetFolderMediaAndFolders();
        this.snotifyService.success("Successfully files Move","", {
          timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
        });
      });
  }
  openRootFolder(isRoot?) {
    this.foldersPathToMove = [];
    this.httpClient
      .post("/Media/GetFolderContent", { folderPath: null })
      .subscribe((res: any) => {
        this.FolderToMove = res.folders;
        this.parentFolderPathMove = res.parentFolderPath;
      });
  }
  GetFolderMediaAndFolders(path?) {
    this.currentFolder.folderPath = path ? path : "";
    this.mediaImages = [];
    this.mediaVideo = [];
    this.mediaDocs = [];
    this.mediaFiles = [];
    this.httpClient
      .post("/Media/GetFolderContent", { folderPath: path ? path : null })
      .subscribe((res: any) => {
        this.folders = res.folders;
        this.allMedia = res.files;
        res.files.forEach((element) => {
          if (element.contentType.indexOf("image/") != -1) {
            this.mediaImages.push(element);
          } else if (element.contentType.indexOf("video/") != -1) {
            this.mediaVideo.push(element);
          } else if (element.contentType.indexOf("application/") != -1) {
            this.mediaDocs.push(element);
          } else if (element.contentType.indexOf("text/") != -1) {
            this.mediaFiles.push(element);
          }
        });

        this.dataSource = new MatTableDataSource(res.files);
        this.parentFolderPath = res.parentFolderPath;
      });
  }
  openFolder(folder, dontAddBread?) {
    this.currentFolder = folder;

    if (!dontAddBread) {
      this.foldersPath.push(this.currentFolder);
    }
    this.GetFolderMediaAndFolders(folder.folderPath);
    this.assigned = [];
  }
  openParentFolder() {
    this.foldersPath.splice(this.foldersPath.length - 1, 1);
    this.currentFolder = [];
    this.GetFolderMediaAndFolders(this.parentFolderPath);
    this.assigned = [];
  }

  selecteFolder(folder) {
    this.selectedFolder = !this.selectedFolder;
  }

  addfolder(folder?) {

    const dialogRef = this.dialog.open(AddFolderDialogComponent, {
      width: '100%', 
      height:  '100%',
      maxHeight: '80%',
      panelClass:   'custom-dialog',
      disableClose :true , 
      data: { folder: folder, path: this.currentFolder.folderPath },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.openFolder(this.currentFolder, true);
        this.openNotifySuccess("Folder " + result);
      }
    });
  }

  openNotifySuccess(message: string) {
    this.snotifyService.success("", message, {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  getThumbnailUrl(url) {
    return window["config"].apiUrl + "/" + url;
  }

  getTimeStamp() {
    return `?` + this.timestamp;
  }

  onFilesAdded(event, drop) {
    var formData = new FormData();
    formData.append("path", this.currentFolder.folderPath);
    this.arryfile = event.addedFiles;

    var FilesToReplace = [];
    var isExist = false;
    for (var i = 0; i < this.arryfile.length; i++) {
      isExist = false;
      for (let index = 0; index < this.allMedia.length; index++) {
        var element = this.allMedia[index];
        if (
          this.arryfile[i].name.split(".").slice(0, -1).join(".") ==
          element.fileName.split(".").slice(0, -1).join(".")
        ) {
          isExist = true;
        }
      }

      if (isExist == true) {
        FilesToReplace.push(this.arryfile[i]);
      } else {
        formData.append("file", this.arryfile[i]);
      }
    }

    if (FilesToReplace.length) {
      const dialogRef = this.dialog.open(DuplicatedFileComponent, {
        data: { FilesToReplace: FilesToReplace },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          for (var i = 0; i < result.length; i++)
            formData.append("file", result[i], result[i].newName);
          this.httpClient
            .post("/Media/SaveMedia", formData)
            .subscribe((res: any) => {
              this.openFolder(this.currentFolder, true);
              this.timestamp = new Date().getTime();
            });
        }
      });
    } else {
      this.httpClient
        .post("/Media/SaveMedia", formData)
        .subscribe((res: any) => {
          this.openFolder(this.currentFolder, true);
        });
    }
  }

  onFilesRejected(event: File[]) {
    console.log(event);
  }

  public open(File, folder) {
    folder = this.currentFolder;
    const dialogRef = this.dialog.open(ViewFileComponent, {
      minWidth: "40vw",
      data: { File, folder },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === "add") {
        this.openFolder(this.currentFolder, true);
        this.openNotifySuccess("Folder added");
      }
      if (result === "refresh") {
        this.openFolder(this.currentFolder, true);
        this.openNotifySuccess("Image saved");
      }
    });
  }

  removeMedia(File) {
    var data = { Path: File.publicUrl };
    this.httpClient.post("/Media/DeleteFile", data).subscribe(
      (res: any) => {
        this.openFolder(this.currentFolder, true);
        this.openNotifySuccess("File Deleted");
      });
  }

  removeFolder(Folder) {
    var data = { Path: Folder.folderPath };
    this.httpClient.post("/Media/DeleteFolder", data).subscribe(
      (res: any) => {
        this.openFolder(this.currentFolder, true);
        this.openNotifySuccess("Folder Deleted");
      });
  }

  copyAddress(val: string) {
    const copy = document.createElement("textarea");
    // copy.value = window['config'].apiUrl + '/' + val;
    while (val.indexOf("\\") !== -1) {
      val = val.replace("\\", "/");
    }

    copy.value = "/" + val;
    document.body.appendChild(copy);
    copy.focus();
    copy.select();
    document.execCommand("copy");
    document.body.removeChild(copy);
    this.openNotifySuccess("File location Copied");
  }
  openEditor(template: TemplateRef<any>) {
    if (this.btnAll == true) {
      this.modalRef = this.modalService.show(template, {
        class: "modal-lg",
        backdrop: "static",
      });
    } else
      this.modalRefImg = this.modalService.show(template, {
        class: "modal-lg",
        backdrop: "static",
      });
    this.showEditor = true;
  }
  download(file) {
    this.httpClient
      .get("/DCMS-backend/" + file.publicUrl, { responseType: "arraybuffer" })
      .subscribe((response: any) => {
        let blob = new Blob([response], { type: file.contentType });
        saveAs(blob, file.fileName);
      });
  }

  toggle(item, event) {
    if (event.target.checked) {
      this.assigned.push(item);
    } else {
      const index = this.assigned.indexOf(item);
      if (index >= 0) {
        this.assigned.splice(index, 1);
      }
    }
  }

  exists(item) {
    return this.assigned.indexOf(item) > -1;
  }

  isIndeterminate() {
    return this.assigned.length > 0 && !this.isChecked();
  }

  isChecked() {
    if (this.btnAll) {
      return this.assigned.length === this.allMedia.length;
    }
    if (this.btnImages) {
      return this.assigned.length === this.mediaImages.length;
    }
    if (this.btnVideos) {
      return this.assigned.length === this.mediaVideo.length;
    }
    if (this.btnFiles) {
      return this.assigned.length === this.mediaFiles.length;
    }
    if (this.btnDocs) {
      return;
    }
  }

  toggleAll(event, page?) {
    if (event.target.checked) {
      this.assigned = [];
      if (this.btnAll) {
        this.allMedia.forEach((row) => {
          this.assigned.push(row);
        });
      }
      if (this.btnImages) {
        this.mediaImages.forEach((row) => {
          this.assigned.push(row);
        });
      }
      if (this.btnVideos) {
        this.mediaVideo.forEach((row) => {
          this.assigned.push(row);
        });
      }
      if (this.btnFiles) {
        this.mediaFiles.forEach((row) => {
          this.assigned.push(row);
        });
      }
      if (this.btnDocs) {
        return;
      }
    } else {
      this.assigned.length = 0;
    }
  }
  downloadSelected(files) {
    for (let i = 0; i < files.length; i++) {
      const element = files[i];
      this.download(element);
    }
  }
  deleteSelected(files) {
    for (let i = 0; i < files.length; i++) {
      const element = files[i];
      this.removeMedia(element);
    }
    this.assigned = [];
  }
  openModal(template: TemplateRef<any>) {
    if (this.assigned.length > 0) {
      this.modalMove = this.modalService.show(template);
    } else {
      this.snotifyService.error("Please select at least one file", "Error", {
        timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
      });
    }
  }
  getButtonClicked(btn) {
    if (btn == 1) {
      this.btnAll = true;
      this.btnImages = false;
      this.btnVideos = false;
      this.btnDocs = false;
      this.btnFiles = false;
    } else if (btn == 2) {
      this.btnAll = false;
      this.btnImages = true;
      this.btnVideos = false;
      this.btnDocs = false;
      this.btnFiles = false;
    } else if (btn == 3) {
      this.btnAll = false;
      this.btnImages = false;
      this.btnVideos = true;
      this.btnDocs = false;
      this.btnFiles = false;
    } else if (btn == 4) {
      this.btnAll = false;
      this.btnImages = false;
      this.btnVideos = false;
      this.btnDocs = true;
      this.btnFiles = false;
    } else {
      this.btnAll = false;
      this.btnImages = false;
      this.btnVideos = false;
      this.btnDocs = false;
      this.btnFiles = true;
    }
    this.assigned = [];
  }
  getEditedFile(event) {
    this.modalRef.hide();
    this.event = event;
    this.newFile();
  }
  newFile() {
    var name = this.event.name;
    var newfile =
      name.substring(0, name.lastIndexOf(".")) +
      "-edit" +
      name.substring(name.lastIndexOf("."));
    var blob = this.event.slice(0, this.event.size);
    var newFile = new File([blob], newfile);
    var formData = new FormData();
    formData.append("path", this.currentFolder.folderPath);
    formData.append("file", newFile);
    this.httpClient
      .post("/Media/SaveMedia", formData)
      .subscribe((res: any) => {});
  }
  setEditFolder(folder, pop) {
    this.folderToEdit = JSON.parse(JSON.stringify(folder));
    this.popup = pop;
  }
  changePopupHandler(popup) {
    this.popup.hide();
    this.folderToEdit = {};
  }
  saveEditedFolder(form) {
    if (form.invalid) {
      Object.keys(form.controls).forEach((feild) => {
        form.controls[feild].markAsTouched(true);
      });
      return;
    }

    var newFolder =
      this.folderToEdit.folderPath.substr(
        0,
        this.folderToEdit.folderPath.lastIndexOf("\\")
      ) +
      "\\" +
      form.value.CatName;

    var data = {
      Path: this.folderToEdit.folderPath,
      FolderName: newFolder,
    };
    this.httpClient.post("/Media/RemaneFolder", data).subscribe((res: any) => {
      this.popup.hide();
      this.openNotifySuccess("Folder Edited successfuly");
      this.openFolder(this.currentFolder, true);
      this.popup = null;
      this.folderToEdit = {};
    });
  }
  moveFolder(i, e) {
    this.folders.splice(e.dragData.index, 1);
    this.folders.splice(i, 0, e.dragData.item);
  }
}
